/* @flow */
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import React from 'react';
import { Roles } from 'user/UserConstants';
import WebNotificationTutorialModal from 'notifications/WebNotificationTutorialModal.jsx';
import { mountModal } from 'lib/modal';

const WebNotificationPreAskModal = React.createClass({
  propTypes: {
    triggeredContext: React.PropTypes.string,
  },

  childContextTypes: {
    eventScreenName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
  },

  getChildContext() {
    return {
      eventScreenName: 'WebNotificationPreAskModal',
      eventProperties: { ui_context: this.props.triggeredContext },
    };
  },

  render() {
    const subtext = (CurrentUser.getUser().getRole() === Roles.teacher)
      ? 'You’ll get notifications for new messages, participants, class owners, and more.'
      : 'You’ll get notifications for new class announcements and messages from your teacher.';
    return (
      <ConfirmDialog
        eventScreenName="WebNotificationPreAskModal"
        {...this.props}
        className="WebNotificationPreAskModal WebNotificationModal"
        size="xsmall"
        hideCloseButton
        hideOnBlur={false}
        title={'Turn on desktop notifications'}
        subtext={subtext}
        image={require('assets/images/notifications/megaphone-phone-pencil-sticky.svg')}
        actionButtonText={'Turn on'}
        cancelButtonText={'Not now'}
        onConfirm={() => {
          mountModal(<WebNotificationTutorialModal />, this);
        }}
        imageSize="large"
      />
    );
  },
});

export default WebNotificationPreAskModal;



// WEBPACK FOOTER //
// ./src/notifications/WebNotificationPreAskModal.jsx